import React from "react";
import {View , Text , StyleSheet} from 'react-native';
import {RFValue} from "react-native-responsive-fontsize";

const Dot = ({full =0 })=>{
    return (
        <>
            {full == 1 ?
                <View style={styles.full}>

                </View>
                :
                <View style={styles.notfull}>

                </View>

            }
        </>

    );
}
export default Dot;

const styles = StyleSheet.create({
    full: {
        marginHorizontal: 3,
        borderRadius : '50%',
        borderWidth : 1,
        width : 20,
        height: 20,
        borderColor : '#44486E',
        backgroundColor : '#FFCC3E',
    },
    notfull: {
        marginHorizontal: 3,
        borderRadius : '50%',
        borderWidth : 1,
        borderColor : '#44486E',
        backgroundColor : 'transparent',
        width : 20,
        height: 20,
    }
})
